import { useEffect, useState } from 'react'
import axios from 'axios'
import { useDataContext } from "../Context/dataContext";

function useFetchDataAdm(accessToken) {
  const { url } = useDataContext();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accessToken) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Obtener datos del usuario
        const response = await axios.get(
          `${url}/Auth/findByTokenAdmin/${accessToken}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setUser(response.data);

      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, url]);

  return { user, loading, error };
}

export {useFetchDataAdm}